import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";
import withStyles from "@material-ui/core/styles/withStyles";
import Helmet from "react-helmet";
import headersList from "Constants/headersList";
import { withSnackbar } from "notistack";
// import get from "lodash/get";
import React, { Component } from "react";
import PermissionDeniedComp from "Component/PermissionDeniedComp/PermissionDeniedComp";
import { IntlProvider } from "react-intl";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { CheckActionPermission } from "Actions/commonAction";
import prorationInfo from "Assets/Svg/proration-upload.svg";
import annualPackageInfo from "../../../../../../Assets/Svg/annual-package-info.svg";
import costInfo from "../../../../../../Assets/Svg/cost-info.svg";
import grossPayInfo from "../../../../../../Assets/Svg/gross-pay-info.svg";
import monthlyPackageInfo from "../../../../../../Assets/Svg/group-9.svg";
import PageHeader from "../../../../../../Component/Headers/pageHeader";
import { instance } from "../../../../../../Actions/AxiosInstance";
import { ErrorMessages } from "../../../../../../Constants";
import SectionHeaderExtraSmall from "../../../../../../Component/Headers/sectionHeaderExtraSmall";

const styles = () => ({
  drawerPaper: {
    width: "30%",
  },
});

class PayrollConfig extends Component {
  constructor(props) {
    super(props);
    this.state = {
      postdata: this.props.payrollconfigdata,
      check: null,
    };
    this.setpostdata = this.setpostdata.bind(this);
    this.save = this.save.bind(this);
    this.editable = this.editable.bind(this);
  }

  componentDidMount() {
    const [isTrue, permissions] = CheckActionPermission("payrollmethod");
    if (isTrue) {
      this.setState({ permissions }, () => {
        this.editable();
      });
    } else {
      this.setState({ permissiondenied: true });
    }
  }

  editable() {
    instance.get("payroll/payrollconfiginit").then((res) => {
      this.setState({
        check: res.data.result[0],
      });
    });
  }

  setpostdata(key, value) {
    this.setState({
      postdata: {
        ...this.state.postdata,
        [key]: value,
      },
    });
  }

  save() {
    const { salaryassignedtypeid, payrolltypeid } = this.state.postdata;
    if (!salaryassignedtypeid || !payrolltypeid) {
      this.props.enqueueSnackbar(ErrorMessages.E1370, { variant: "error" });
      return;
    }
    instance
      .post("payroll/payrollconfig", this.state.postdata)
      .then(() => {
        this.props.enqueueSnackbar(ErrorMessages.E0000, { variant: "success" });
      })
      .catch((error) => {
        this.props.enqueueSnackbar(
          error.response ? error.response.data.error.message : error.message,
          { variant: "error" },
        );
      });
  }

  render() {
    const {
      postdata: { salaryassignedtypeid, payrolltypeid },
    } = this.state;
    return (
      <div>
        <IntlProvider locale="en">
          <div className="content-outer-wrapper">
            <Helmet>
              <title>{headersList.Config.PayrollMethod.header}</title>
            </Helmet>
            {this.state.permissiondenied ? (
              <div className="position-rel">
                <PermissionDeniedComp />
              </div>
            ) : (
              <Grid container>
                <Grid item xs={12} md={12} sm={2}>
                  <PageHeader header="Configure settings" />
                </Grid>
                <Grid item xs={12} md={12} sm={2}>
                  <div className="setup-block-wrapper width60 margin-bottom-24">
                    <p className="normal-dark-secondary margin-bottom-8">
                      How are employees assigned salary packages?
                    </p>
                    <div
                      onClick={() =>
                        this.state.permissions &&
                        this.state.permissions.editable &&
                        this.state.check &&
                        this.state.check.iseditable &&
                        this.setpostdata("salaryassignedtypeid", 1)
                      }
                      className={`setup-block annual-package ${
                        salaryassignedtypeid == 1 && "block-selected"
                      }`}
                    >
                      <span className="extra-small-dark-secondary margin-top-16 display-block text-center">
                        Annual package
                      </span>
                      <span
                        className="annual-package-info"
                        style={{
                          position: "absolute",
                          display: "block",
                          right: -280,
                          top: 0,
                        }}
                      >
                        <img src={annualPackageInfo}></img>
                      </span>
                    </div>
                    <div
                      onClick={() =>
                        this.state.permissions &&
                        this.state.permissions.editable &&
                        this.state.check &&
                        this.state.check.iseditable &&
                        this.setpostdata("salaryassignedtypeid", 2)
                      }
                      className={`setup-block monthly-package ${
                        salaryassignedtypeid == 2 && "block-selected"
                      }`}
                    >
                      <span className="extra-small-dark-secondary margin-top-16 display-block text-center">
                        Monthly package
                      </span>
                      <span
                        className="monthly-package-info"
                        style={{
                          position: "absolute",
                          display: "block",
                          right: -280,
                          top: 0,
                        }}
                      >
                        <img src={monthlyPackageInfo}></img>
                      </span>
                    </div>
                  </div>
                  <div className="setup-block-wrapper width60">
                    <p className="normal-dark-secondary margin-bottom-8">
                      Which method would you like to choose for salary
                      assignment?
                    </p>
                    <div
                      className={`setup-block cost ${
                        payrolltypeid == 1 && "block-selected"
                      }`}
                      onClick={() =>
                        this.state.permissions &&
                        this.state.permissions.editable &&
                        this.state.check &&
                        this.state.check.iseditable &&
                        this.setpostdata("payrolltypeid", 1)
                      }
                    >
                      <span className="extra-small-dark-secondary margin-top-16 display-block text-center">
                        Cost to company
                      </span>
                      <span
                        className="cost-info"
                        style={{
                          position: "absolute",
                          display: "block",
                          right: -272,
                          top: 0,
                        }}
                      >
                        <img src={costInfo}></img>
                      </span>
                    </div>
                    <div
                      className={`setup-block gross-pay ${
                        payrolltypeid == 2 && "block-selected"
                      }`}
                      onClick={() =>
                        this.state.check &&
                        this.state.check.iseditable &&
                        this.setpostdata("payrolltypeid", 2)
                      }
                    >
                      <span className="extra-small-dark-secondary margin-top-16 display-block text-center">
                        Gross pay
                      </span>
                      <span
                        className="gross-pay-info"
                        style={{
                          position: "absolute",
                          display: "block",
                          right: -370,
                          top: 0,
                        }}
                      >
                        <img src={grossPayInfo}></img>
                      </span>
                    </div>
                    <div
                      className={`setup-block gross-pay ${
                        payrolltypeid == 3 && "block-selected"
                      }`}
                      onClick={() =>
                        this.state.permissions &&
                        this.state.permissions.editable &&
                        this.state.check &&
                        this.state.check.iseditable &&
                        this.setpostdata("payrolltypeid", 3)
                      }
                    >
                      <span className="extra-small-dark-secondary margin-top-16 display-block text-center">
                        Proration upload
                      </span>
                      <span
                        className="gross-pay-info"
                        style={{
                          position: "absolute",
                          display: "block",
                          right: -370,
                          top: 0,
                        }}
                      >
                        <img src={prorationInfo}></img>
                      </span>
                    </div>
                  </div>
                  <div className="margin-top-10">
                    <SectionHeaderExtraSmall header="📌 Once you assign salary pkg to employee, this cannot be changed until next cycle" />
                  </div>
                  <div>
                    {this.state.permissions &&
                      this.state.permissions.editable &&
                      this.state.check &&
                      this.state.check.iseditable && (
                        <Button
                          className="btn btn-primary-md-blue"
                          variant="contained"
                          onClick={this.save}
                        >
                          Save
                        </Button>
                      )}
                  </div>
                </Grid>
              </Grid>
            )}
          </div>
        </IntlProvider>
      </div>
    );
  }
}

export default withRouter(
  connect()(withStyles(styles)(withSnackbar(PayrollConfig))),
);

const POST_DATA = {
  salaryassignedtypeid: null, // 1,
  payrolltypeid: null, // 1,
  roundofftypeid: null, // 1,
  islwfdeduction: null, // true,
  isptdeduction: null, // false
};

/**
post("payroll/payrollconfig",
{
  salaryassignedtypeid: 1,
  payrolltypeid: 1,
  roundofftypeid: 1,
  islwfdeduction: true,
  isptdeduction: false
})
 */
